export const phoneRegex = /^09[0-9]{9}$/
export const passwordRegex = /^(?=.*\d)[\p{L}\p{N}\p{S}\p{P}\s]{6,}$/u
export const numberRegex = /^[0-9۰-۹]*$/
export const shebaRegex = /^IR[0-9]{24}$/
export const cardRegex = /^[0-9]{16}$/
export const nationalCodeRegex = /^[0-9]{10}$/

export const ValidationsRegexs = {
  phoneRegex,
  passwordRegex,
  numberRegex,
  shebaRegex,
  cardRegex,
  nationalCodeRegex,
}

export default ValidationsRegexs
